import React, { useState } from "react";
import { AdminContext } from "../contexts/AdminContext";
import { getCookieItem } from '../helpers/functions/cookie'

type AdminProps = { children: React.ReactNode }

const AdminProvider: React.FC<AdminProps> = ({ children }) => {
  const [admin, setAdmin] = useState<any>(getCookieItem('eden_admin'))

  return (
    <AdminContext.Provider
      value={{
        admin,
        setAdmin
      }}
    >
      {children}
    </AdminContext.Provider>
  )
}

export default AdminProvider